// Hộp thư info@ của Mint-Booking (MAIL · OLDER · MX · MT trong script board). Dữ liệu mẫu, chưa nối hộp thư thật.
import { fold } from '@hana/data';
import { BOOKING_COVER } from './booking';

export type MailKind = 'req' | 'vessel' | 'notice' | 'none' | '';
export type MailScope = 'mine' | 'un' | 'all' | 'solved';

export interface Mail {
  i: number;
  from: string;
  subj: string;
  label: string;
  /** người phụ trách; '' = chưa PIC */
  pic: string;
  time: string;
  body: string;
  kind: MailKind;
  /** khách khớp theo thư */
  kh: string;
  /** phút còn lại tới hạn SLA (âm = quá hạn, 0 = không áp) */
  slaMin: number;
  atts: number;
}

// [from, subj, label, pic, time, body, kind, kh, slaMin, atts]
type Row = readonly [string, string, string, string, string, string, MailKind, string, number, number];
const ROWS: readonly Row[] = [
  ['logistics@••••.vn', 'Booking request W45 · 15x40HC VNSGN → KRKAN', 'BOOKING', '', '09:20', 'Please book 15x40HC VNSGN → KRKAN, ETD week 45, cargo: Sawn wood, 1440 CARTONS.', 'req', 'ARRIVE', 22, 2],
  ['noreply@••••.com', 'Booking Confirmation SGNGCQ104300 / ONE BLUE JAY 043E', 'BOOKING', 'PHUONGHT', '09:12', 'Your booking SGNGCQ104300 has been confirmed.', '', 'GREENBUD', 18, 1],
  ['vn.ops@••••.com', 'Vessel delay notice — WAN HAI 622 W028 (TypeNotice Delay)', 'LICH_TAU', 'NHITHT', '09:05', 'Please be advised WAN HAI 622 W028 delays 30h due to berth congestion at GEMALINK.', 'vessel', '', 25, 1],
  ['pricing@••••.com', 'GRI effective 01/Nov/2026 — Asia to Middle East', 'NOTICE', '', '08:47', 'MSK will apply GRI effective 01/Nov/2026 for Asia – Middle East cargo.', 'notice', '', 0, 0],
  ['cs@••••.com', 'Missing VGM — YMLU4410237 / YMJAM490367112 (VGMStatus Pending)', 'SI_VGM', 'THUYNTT', '08:31', 'VGM has not been received for YMLU4410237. VGM cut-off 23/Oct 11:00.', '', 'SAVITA', -12, 0],
  ['reefer@••••.com', 'URGENT: temperature deviation 40RH WHSU8821004', 'URGENT_CASE', 'MAITTN', '08:20', 'Set point -18°C, reading -12°C at 07:55. Please confirm LOI / instruction.', '', 'MKAGRISEA', 8, 1],
  ['doc@••••.vn', 'Draft B/L ready for proof — KMTC XIAMEN 2608N', 'CHUNG_TU', 'THUYNTT', '08:02', 'Draft B/L VN01175201 (TypeHBL Surrender) is ready. Please confirm before 23/Oct 12:00.', '', 'SAVITA', 41, 1],
  ['einvoice@••••.vn', 'Hoá đơn điện tử phí CSHT tháng 10/2026', 'THANH_TOAN', 'LIENNTK', '07:44', 'Hoá đơn điện tử số 0012874 phí sử dụng hạ tầng cảng biển.', '', '', 0, 2],
  ['newsletter@••••.com', 'Weekly market update — week 43', 'KHAC', '', '07:30', 'Freight market weekly digest.', 'none', '', 0, 0],
  ['noreply@••••.com', 'Booking Confirmation SGNGCN981200 / WAN HAI 622', 'BOOKING', 'PHUONGHT', '17/Oct', 'Your booking SGNGCN981200 has been confirmed.', '', '', 0, 0],
  ['vn.ops@••••.com', 'Closing change · ONE BLUE JAY 043E', 'LICH_TAU', 'PHUONGHT', '17/Oct', 'CY closing revised to 22/Oct 20:00.', '', '', 0, 0],
  ['export@••••.vn', 'Amend RQ · 2x40HC → 3x40HC · W44', 'BOOKING', 'PHUONGHT', '16/Oct', 'Please amend to 3x40HC.', 'req', '', 0, 0],
  ['cs@••••.com', 'Space release · YM CERTAINTY 089N', 'BOOKING', 'PHUONGHT', '16/Oct', 'Space released for 2x40HC.', '', '', 0, 0],
  ['noreply@••••.tw', 'Booking amendment 6470297120', 'BOOKING', 'PHUONGHT', '15/Oct', 'Amendment confirmed.', '', '', 0, 0],
  ['doc@••••.com', 'VGM reminder · SGNGCQ104300', 'BOOKING', 'PHUONGHT', '15/Oct', 'Kindly submit VGM before cut-off.', '', '', 0, 0],
  ['bkg@••••.com', 'Booking Confirmation KMTCHCM5512408', 'BOOKING', 'TRANTPB', '14/Oct', 'Booking confirmed.', '', '', 0, 0],
  ['logistics@••••.vn', 'RQ W44 · 1x40RH VNSGN → JPTYO', 'BOOKING', 'PHUONGHT', '14/Oct', 'Please book 1x40RH to Tokyo.', 'req', '', 0, 0],
];

export const MAILS: readonly Mail[] = ROWS.map((r, i) => ({ i, from: r[0], subj: r[1], label: r[2], pic: r[3], time: r[4], body: r[5], kind: r[6], kh: r[7], slaMin: r[8], atts: r[9] }));

/** Thứ tự nhãn như board (theo lần xuất hiện đầu tiên). */
export function mailLabelCounts(mails: readonly Mail[]): Array<[string, number]> {
  const by = new Map<string, number>();
  for (const m of mails) by.set(m.label, (by.get(m.label) ?? 0) + 1);
  return [...by.entries()];
}

export const isMineMail = (m: Mail, me: string) => !!m.pic && (m.pic.toUpperCase().startsWith(me) || BOOKING_COVER[m.pic] === me);
export const isUnMail = (m: Mail) => !m.pic && m.kind !== 'none';

export function mailScopeCounts(mails: readonly Mail[], me: string): Record<MailScope, number> {
  return { mine: mails.filter((m) => isMineMail(m, me)).length, un: mails.filter(isUnMail).length, all: mails.length, solved: 0 };
}

export interface MailQuery {
  me: string;
  scope: MailScope;
  label?: string;
  q?: string;
}

export function queryMails(mails: readonly Mail[], { me, scope, label, q }: MailQuery): Mail[] {
  if (scope === 'solved') return [];
  const n = fold(q ?? '').trim();
  return mails.filter(
    (m) =>
      (scope === 'all' || (scope === 'mine' ? isMineMail(m, me) : isUnMail(m))) &&
      (!label || m.label === label) &&
      (!n || fold(`${m.from} ${m.subj} ${m.body}`).includes(n)),
  );
}

/** Job khớp thư: mã trong tiêu đề → booking của yêu cầu có trong tiêu đề → job board đã ghi ở cột "why" của thư. */
const MAIL_JOB: Readonly<Record<number, string>> = { 9: 'SE260617730', 13: 'SE260621380', 14: 'SE260638710' };
export function mailJob(m: Mail, requests: ReadonlyArray<{ jobId: string; bookingNo: string | null }>): string {
  return /S[ELT]26\d{7}/.exec(m.subj)?.[0] ?? requests.find((r) => r.bookingNo && m.subj.includes(r.bookingNo))?.jobId ?? MAIL_JOB[m.i] ?? '';
}

/** Mail có SLA hiển thị: bỏ thư không cần đọc, KHAC, THANH_TOAN, hoặc chưa có hạn. */
export const mailHasSla = (m: Mail) => m.kind !== 'none' && m.label !== 'KHAC' && m.label !== 'THANH_TOAN' && m.slaMin !== 0;
